import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CONST_AWS_API, DEFAULT_IMAGE} from 'src/app/core/constants';
import { environment } from 'src/environments/environment';
import { API } from 'aws-amplify';
import { UserService } from 'src/app/core/services/user.service';
import { observable, Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { AppService } from 'src/app/core/services/app.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
// import { ThrowStmt } from '@angular/compiler';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from 'src/app/core/services/storage.service';
import { UtilityService } from 'src/app/core/services/utility.service';
// import { throwMatDialogContentAlreadyAttachedError } from '@angular/material';
declare let $: any;
@Component({
  selector: 'app-product-marketplace',
  templateUrl: './product-marketplace.component.html',
  styleUrls: ['./product-marketplace.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProductMarketplaceComponent implements OnInit {
  public isBlue = false;
  primaryColor = environment.themeColors['primaryColor'];
  colors: boolean[];
  selectedIndex: number = null;
  getCurrency: any;
  getCurrencyType: any;
  currencyInfoSubscription: Subscription;
  currentLocation: {};
  categoryList: any = []
  brandProductsList = [];
  overallFilter: any = []
  bannerDataCollection: any;
  collectionOfBanner: any;
  descriptionOfBanner: any;
  imageOfBanner: any;
  bannerTitle: any;
  catogeryName: any;
  bannerDataProduct: any;
  endPage: any;
  currentPage: any;
  ValueSlectedSort: any;
  selectedSortValue: string;
  orderValue: string;
  searchfil: any;
  selectedValue: any;
  channelName: string;

  mysubdata: any;
  myCollection: any;
  myFrom: any;
  myParentCollection: any;
  mySubData: any;
  myFilterName: any;
  excludeFlag: boolean = true;
  price: any = []
  brandData: any;
  selectedbrandName: any;
  collectionIdUrl: any;
  selectedDiscountValue: any;
  stockData = { "name": 'stock', value: 1 }
  settingsData: any = {};
  settingsDataSubscription: Subscription;


  constructor(private router: Router,
    private route: ActivatedRoute,
    private userService: UserService, private commanService: CommanSubscribeService, private appService: AppService, private ngxLoader: NgxUiLoaderService, public toaster: ToastrService, private storageService: StorageService,
    private utilityService: UtilityService
  ) {
    this.featureChecked = false;
  }

  public sortList = [
    { name: "Old-New" },
    { name: "New-Old" },
    { name: "Lowest-Highest" },
    { name: "Highest-Lowest" },
    // { name: "Auction Ending soon" },
    { name: "Mosted Viewed" },
  ];
  dumaarr = new Array<number>(3)
  ngOnInit() {
    console.log("product marketplace component loaded");
    this.channelName = this.route.parent.snapshot.params['channelName'];

    // this.toggle();
    this.dumaarr.push(20);
    $(window).scroll(function () {
      let elem = document.getElementById('changes');
      if (elem) {
        let rect = elem.getBoundingClientRect();
        if (rect && rect.top < 5) {
          elem.classList.add('topstickey');
        }
        else {
          if (elem.classList.contains('topstickey')) {
            elem.classList.remove('topstickey');
          }
        }
        // console.log(rect.top, "changes")
      }
    });
    this.collectionIdUrl = this.route.snapshot.params.collection_id;
    this.storageService.deleteItem("product_info");
    // Default sort is applied up front so the first product request is already sorted (no follow-up sort request).
    this.sortData = this.selectedValue = this.ValueSlectedSort = "New-Old";
    this.selectedSortValue = "date_added";
    this.orderValue = "desc";
    this.getSearchlist();
    // $('#changes').waypoint(function () {
    //   alert('You have scrolled to an entry.');
    // }, { offset: '100%' });
    this.getFilterData('loadpage');
    this.getCurrency = this.storageService.getItem('currency');
    this.settingsDataSubscription = this.commanService.getICWebpageThemeSettings().subscribe(async (response) => {
      this.settingsData = response;
    });
    this.settingsData = this.commanService.icWebpageSettingsData;
    this.currencyInfoSubscription = this.commanService.getCurrencyInfo().subscribe(response => {
      if (response) {
        this.getCurrency = this.storageService.getItem('currency');
      }
      this.getFilterData('loadpage');
    });
  }
  // toggle() {
  //   $(document).ready(function () {
  //     $('#sidebarCollapse').on('click', function () {
  //       $('#sidebar').toggleClass('active');
  //     });
  //   });
  //   $('#sidebar').trigger('click');
  // }
  productOverview(collectionId, prodId, orgId, networkGroupId?) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Clicked on product with id: ${prodId} and userName is ${userId}`);
    const payload = {
      actionType: "product",
      metaData: {
        title: `Clicked on product with id: ${prodId} and userId is ${userId}`,
        productId: prodId,
        orgId: orgId,
        collectionId: this.collectionIdUrl,
        timeStamp: new Date().toISOString()
      },
      organizationId: orgId || null,
      networkGroupId: networkGroupId || null,
      clickAction: `product`
    }
    this.commanService.sendTriggeredEvent(payload);
    const currentUrl = this.router.url;

  // detect merchandise flow
    const isMerchandise = currentUrl.includes('/merchandise');

    this.router.navigate([
      isMerchandise
        ? `${this.commanService.getChannelBasePath(this.channelName)}/merchandise/overviewProduct/${prodId}/${this.collectionIdUrl}`
        : `/network-market/overviewProduct/${prodId}/${this.collectionIdUrl}`
    ]);
  }

  getSearchlist() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: {
        "type": "collection",
        "filters": [{ "name": "collection_id", "value": [this.collectionIdUrl] }]
      }
    }
    this.ngxLoader.start('banner');
    API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.SEARCH_MARKETLSIT, data).then(response => {
      this.ngxLoader.stop('banner');
      this.bannerDataCollection = response.data.body.hits.hits;
      for (var product of this.bannerDataCollection) {
        this.collectionOfBanner = product._source;
        this.descriptionOfBanner = this.collectionOfBanner.description;
        this.imageOfBanner = this.collectionOfBanner.images;
        this.bannerTitle = this.collectionOfBanner.title;
        this.catogeryName = this.collectionOfBanner.category
      }
    }).catch(error => {
      this.ngxLoader.stop('banner');
    });
  }
  // API call to get collections from start ->stating to limt -> to get no of data from response
  // API call to get collections from start ->stating to limt -> to get no of data from response
  userInfo: any;
  start = 0;
  found = 0;
  getCollections(from?) {
    if (!from) {
      this.start = 0;
    }
    this.userInfo = this.commanService.userInfo;
    let url = "marketSearch";
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "type": "product",
        "start": this.start,
        "limit": 16,
        //"filters": [{ "name": "collection_ids", "value":  this.collectionIdUrl }]

      }
    }
    API.post(environment.AWS_Cognito.apiName, url, myInit).then(res => {
      let response: any = {};
      response.data = res.data.body;
      if (response.data.hits.hits) {
        this.found = response.data.hits.total?.value;
        response.data.hits.hits.forEach(element => {
          this.brandProductsList.push(element)
        });
        this.categoryList = response.data.aggregations.category.buckets.map(bucket => ({ ...bucket, value: bucket.key, fillter: false }));
        if (!from) {
          // this.getOverallFilter(response);
        }
        console.log(this.categoryList, this.overallFilter, "getcategorylistdata")
        this.entredapi = false;
        this.ngxLoader.stop();
      }
    }).catch(error => {
    });
  }
  getOverallFilter(response) {
    this.overallFilter = [];
    this.price = []

    if (response.data?.aggregations) {
      Object.entries(response.data?.aggregations).forEach((data: any) => {
        let newdata = { 'name': '', 'value': [] }

        if (data[0] == "attributes") {
          data[1].buckets.forEach(el => {
            el.fillter = false;
          });
          newdata.name = data[0];
          data[1].buckets.forEach(e => {
            let values = []
            e.values.forEach(el => {
              values.push({ name: el, filter: false })
            })
            e.values = values;

          })
          newdata.value = data[1];
          this.overallFilter.push(newdata);
        }
        if (data[0] == "brand") {
          data[1].buckets.forEach(da => {
            da.filter = false;
          })
          this.brandData = data[1].buckets
        }
        // else if (data[0] == "discount" && data[1].buckets.length > 0) {
        //   data[1].buckets.forEach(el => {
        //     if (this.filterArray.length > 0) {
        //       this.filterArray.forEach(element => {
        //         if (element.name == data[0] && element.value) {
        //           el.fillter = true;
        //         }
        //       });
        //     }
        //     else {
        //       el.fillter = false;
        //     }
        //   });
        //   newdata.name = data[0];
        //   newdata.value = data[1];
        //   this.overallFilter.push(newdata);
        // }
        else if (data[0] == "price" && data[1].buckets.length > 0) {
          // data[1].buckets.forEach(el => {
          //   let values = el.value.split("-");
          //   if (this.maxinput.length > 0 && this.mininput.length > 0 && el.max >= this.mininput && values[1] <= this.maxinput) {
          //     el.filter = true;
          //   }
          //   else {
          //     el.filter = false;
          //   }
          // });
          data[1].buckets.forEach(element => {

            element.filter = false
          });
          this.price = data[1].buckets;
          newdata.name = data[0];
          newdata.value = data[1];
          console.log(this.price);

          // this.mininput = Math.min.apply(null, this.price) == 0 ? 1 : Math.min.apply(null, this.price);
          // this.maxinput = Math.max.apply(null, this.price) == 0 ? 1 : Math.max.apply(null, this.price);
          // this.priceValues();
          // this.overallFilter.push(newdata);
        }

      });
    }
  }

  // discountData(discountSelected) {
  //   if (discountSelected) {
  //     this.selectedDiscountValue = discountSelected;      
  //     this.myFrom = "filter"
  //     this.getFilter(this.myCollection, this.myFrom, this.myParentCollection, this.mySubData, this.myFilterName)
  //   }
  // }
  selectedDiscount: any = ''
  discountfilter = { name: 'discount', value: '' }
  disountFun(data) {
    if (data == '1') {
      if (this.selectedDiscount == '' || this.selectedDiscount == '0') {
        this.selectedDiscount = '1';
      }
      else {
        this.selectedDiscount = '';
      }
    }
    else if (data == '0') {
      if (this.selectedDiscount == '' || this.selectedDiscount == '1') {
        this.selectedDiscount = '0';
      }
      else {
        this.selectedDiscount = '';
      }
    }
    this.discountfilter.value = this.selectedDiscount;
    // if (this.selectedDiscount != '') {
    this.getFilterData('discount')
    // }
  }

  entredapi: boolean = false;
  onScrollDown() {

    this.entredapi = true;
    this.start += 5;
    if (this.CollectionFilter.length > 0 || this.filterArray.length > 0 || this.query.length > 0) {
      if (this.found != this.brandProductsList.length) {
        this.ngxLoader.start()
        this.getFilterData("getnext");
      }
      else {
        this.ngxLoader.stop();
        this.entredapi = false;
        // this.toaster.success("End of Data");
      }
    }
    else {
      if (this.brandProductsList && this.brandProductsList.length > 0) {
        if (this.found != this.brandProductsList.length) {
          this.ngxLoader.start()
          this.getCollections("nextdata");
        }
        else {
          this.ngxLoader.stop();
          this.entredapi = false;
          // this.toaster.success("End of Data");
        }
      }
    }
  }

  CollectionFilter = []
  filterArray: any = [];
  dumArray: any = []

  // excludeStock() {
  //   debugger
  //   if (this.excludeFlag == true) {
  //     this.excludeFlag = false
  //     this.myFrom = "filter"
  //     this.getFilter(this.myCollection, this.myFrom, this.myParentCollection, this.mySubData, this.myFilterName)
  //   }
  // }
  // getstock() {
  //   if (this.stockData.value == 1) {
  //     this.stockData.value = 0;
  //     let element = document.getElementById('stockButton');
  //   }
  //   else {
  //     this.stockData.value = 1;
  //   }
  //   this.getFilterData('stock')
  // }
  brandFill: boolean = false;
  brandDataParam(brandSelected, clear?) {
    console.log(this.brandData)
    if (brandSelected && !clear) {
      this.brandData.forEach(el => {
        if (el.value == brandSelected && this.brand.indexOf(brandSelected) == -1) {
          el.filter = true;
          this.brand.push(brandSelected)
        }
        else if (el.value == brandSelected && this.brand.indexOf(brandSelected) != -1) {
          el.filter = false;
          this.brand = this.brand.filter(b => b.toLowerCase() != brandSelected.toLowerCase())
        }
      })


      console.log(this.brand, 'changes for')
      this.selectedbrandName = brandSelected;
      this.myFrom = "filter"
      let newdata = this.dumArray.filter(a => a.name == 'brand');
      console.log(newdata, "newdata>>>>")
      if (newdata.length == 0) {
        if (this.brand.length > 0) {
          this.dumArray.push({ 'name': "brand", 'value': this.brand })
        }

      }
      else {
        this.dumArray.forEach(data => {
          if (data.name == "brand") {
            data.value = this.brand;
          }
        })
      }
      // this.getFilter(this.myCollection, this.myFrom, this.myParentCollection, this.mySubData, this.myFilterName)
    }
    else if (clear) {
      this.brandData.forEach(el => {
        el.filter = false;
      });
      this.brand = [];
    }
    if (this.brand.length > 0) {
      this.brandFill = true;
    }
    else {
      this.brandFill = false;
    }
    this.applyfilter();
    // this.getFilterData('')
  }
  mininput: any = [];
  maxinput: any = [];
  minerror: boolean = false;
  maxerror: boolean = false;
  minmessage = "";
  maxmessage = "";
  range: any = {}
  values = [];

  priceValues(min, max, filter, from) {
    this.range = {};
    if (from == 'add') {
      this.price.forEach(e => {
        console.log(e, "price>>>>")
        // console.log(e.from ,min ,e.max,max)
        if (e.from == min && e.to == max && !e.filter) {
          e.filter = true;
          let b = { min: min, max: max };
          this.values.push(b)
        }
        else if (e.from == min && e.to == max && e.filter) {
          e.filter = false;
          this.values = this.values.filter(val => val.min != min && val.max != max);
        }
      });

    }
    if (from == 'clear') {
      this.values = [];
      this.price.forEach(element => {
        element.filter = false;
      });

    }
    console.log('')
    if (this.values.length > 0) {
      let n = { "field": "price", "value": this.values };
      this.range = n;
      this.priceClear = true;
    }
    else {
      this.range = {};
      this.priceClear = false;
    }
    // if (from == 'price') {
    this.getFilterData("price");

    // }
  }

  brand: any = [];
  attributes: any = [];

  getFilter(colleciton?, from?, parentCollection?, subdata?, filterName?) {
    this.myCollection = colleciton
    this.myFrom = from
    this.myParentCollection = parentCollection
    this.mySubData = subdata
    this.myFilterName = filterName
    this.mysubdata = subdata

    if (from == 'filter') {
      console.log("filter entered")

      if (this.overallFilter.length > 0) {
        this.dumArray = []
        // if (this.excludeFlag == true) {
        //   debugger
        //   this.dumArray.push({ 'name': 'stock', 'value': '1' });
        // } else {
        // }
        this.overallFilter.forEach(fil => {
          if (fil.name == parentCollection) {
            fil.value.buckets.forEach(fildata => {
              console.log(fildata, "changes forFill")
              fildata.values.forEach(element => {
                let attri = fildata.name + '#' + element.name;
                console.log(this.attributes.indexOf(attri),)
                if (parentCollection.toLowerCase() == 'attributes' && this.mySubData.toLowerCase() == element.name.toLowerCase() && this.attributes.indexOf(attri) == -1) {
                  this.attributes.push(attri);
                  element.filter = true;
                }
                else if (parentCollection.toLowerCase() == 'attributes' && this.mySubData.toLowerCase() == element.name.toLowerCase() && this.attributes.indexOf(attri) != -1) {
                  element.filter = false;
                  this.attributes = this.attributes.filter(at => at.toLowerCase() != attri.toLowerCase());
                }
              });
              let newfilter = fildata.values.filter(a => a.filter == true)
              if (newfilter.length > 0) {
                fildata.fillter = true;
              }
              else {
                fildata.fillter = false;
              }
            });
            console.log(this.attributes, "attributes data")
            if (this.attributes.length > 0) {
              this.dumArray.push({ 'name': parentCollection, 'value': this.attributes });
            }
            let newdata = this.dumArray.filter(a => a.name == 'brand');
            if (newdata.length == 0) {
              if (this.brand.length > 0) {
                this.dumArray.push({ 'name': "brand", 'value': this.brand })
              }
            }
            else {
              this.dumArray.forEach(data => {
                if (data.name == "brand") {
                  data.value = this.brand;
                }
              })
            }


          }

          // if(this.selectedDiscountValue){
          // this.dumArray.push({ 'name': "discount", 'value': this.selectedDiscountValue });
          // }



        })
      }
      this.applyfilter();
    }
  }
  closeFilter() {
    $('#getingFilter').removeClass("show");
  }
  available: boolean = false;
  getcheckedvalue(event) {
    if (event.checked) {
      this.stockData.value = 0;
      this.available = true;
    }
    else {
      this.stockData.value = 1;
      this.available = false;
    }
    this.getFilterData('stock');

  }
  query: any = '';
  netClear: boolean = false;
  priceClear: boolean = false;
  discountClear: boolean = false;
  featureChecked: boolean = false;
  getFilterData(from?) {
    this.ngxLoader.start()
    this.userInfo = this.commanService.userInfo;
    let filterData = [];
    if (from != 'getnext') {
      this.start = 0;
    }
    filterData = this.getFilterSearch();
    let url = "marketSearch";
    let body = {
      "type": "product",
      "filters": filterData.concat({ "name": "collection_ids", "value": [this.collectionIdUrl] }),
      // "filters": filterData,
      "currency": this.getCurrency,
      'q': this.query,
      "range": Object.keys(this.range).length > 0 ? this.range : undefined,
      "start": this.start,
      "sort": {
        "field": this.selectedSortValue,
        "order": this.orderValue,
      },
      limit: 16
    }
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: body
    }
    API.post(environment.AWS_Cognito.apiName, url, myInit).then(res => {
      let response: any = {};
      response.data = res.data.body;
      this.ngxLoader.stop();
      if (response.data.hits.hits.length > 0 && !this.featureChecked) {
        const organizationId = response.data.hits.hits[0]._source.organization_id;
        this.utilityService.loadOrganizationFeatures(organizationId).then((featureList) => {
          if (!this.utilityService.isActiveFeature(featureList, 'merchandise')) {
            this.featureChecked = true;
            this.toaster.warning('Merchandise feature is not accessible to this network');
            this.router.navigateByUrl('/');
          }
        })
      }
      if (response.data.hits.hits) {
        this.found = response.data.hits.total?.value;
        if (from != 'getnext') {
          this.brandProductsList = response.data.hits.hits || [];


        }
        else {
          response.data.hits.hits.forEach(element => {
            this.brandProductsList.push(element)
          });
        }
        let netfill = filterData.filter(a => a.name == 'attributes');
        let brandfill = filterData.filter(a => a.name == 'brand');
        let Disfill = filterData.filter(a => a.name == 'discount');
        this.netClear = netfill && netfill.length > 0 ? true : false;
        this.discountClear = Disfill && Disfill.length > 0 ? true : false;
        // this.priceClear = body.range && body.range.length > 0 ? true : false;
        if (from == 'loadpage') {
          this.getOverallFilter(response);
        }
        if (Object.keys(this.sortData).length == 0) {
          this.sortbyfilter('New-Old');
        }
      }
      this.entredapi = false;
      this.entredapi = false;
    }).catch(error => {
      this.ngxLoader.stop();
      this.entredapi = false;
    });


  }
  getFilterSearch() {
    let filterData = [];
    filterData.push(this.stockData);
    this.categoryList.forEach(data => {
      let Obj = { "name": 'category', "value": '' };
      if (data.fillter) {
        Obj.value = data.value;
        filterData.push(Obj);
      }
    })
    if (this.filterArray.length > 0) {
      this.filterArray.forEach(data => {
        filterData.push(data);
      })
    }
    console.log(this.categoryList, this.selectedDiscount, "this.selectedDiscount0")
    if (this.selectedDiscount != '' && this.discountfilter.value != '') {
      console.log(this.selectedDiscount, "this.selectedDiscount1")
      filterData.push(this.discountfilter)
    }
    return filterData;

  }
  clearFilter(data, parentData?) {
    if (parentData == 'attributes') {
      this.filterArray = [];
      this.dumArray = [];
      this.overallFilter.forEach(fil => {
        console.log(fil, "fil")
        if (fil.name == parentData.toLowerCase()) {
          fil.value.buckets.forEach(fildata => {
            console.warn(fildata, "filldata")
            fildata.values.forEach(element => {
              if (fildata.name == data && element.filter) {
                console.log(fildata.name, "fillter>>>");
                let atri = fildata.name + "#" + element.name
                element.filter = false;
                this.attributes = this.attributes.filter(a => a != atri);
                fildata.fillter = false;
              }
            });
          });
        }
        if (this.attributes.length > 0) {
          this.dumArray.push({ 'name': 'attributes', 'value': this.attributes });
        }
        if (this.brand.length > 0) {
          this.dumArray.push({ 'name': "brand", 'value': this.brand })
          // console.log(this.dumArray, "this thdummarray")
        }
        this.filterArray = this.dumArray;
      });

    }
    else if (data == 'discount') {
      this.selectedDiscount = '';
      this.discountfilter.value = '';
    }
    this.getFilterData('clearfilter');

  }


  applyfilter(from?) {
    this.sortData;
    if (from) {
      this.available = false;
      this.stockData.value = 1;
      this.dumArray = [];
      this.sortData = {};
      this.range = {};
      this.mininput = "";
      this.maxinput = "";
      this.attributes = [];
      this.brand = [];
      this.selectedDiscount = '';
      this.overallFilter.forEach(fil => {
        console.log(fil, "fill>>>>")
        fil.value.buckets.forEach(fildata => {
          console.log(fildata, "fill>>>>")
          fildata.values.forEach(element => {
            element.filter = false;
          });
        });
      })
      this.brandData.forEach(brand => {
        brand.filter = false;
      })

    }
    this.filterArray = this.dumArray;
    this.getFilterData();

  }

  navcolor: boolean = false;
  toggleNava() {
    this.navcolor = !this.navcolor;

    setTimeout(() => {
      let check = document.querySelector('.mat-checkbox-frame') as HTMLElement;
      let sfc = environment.themeColors['secondaryFontColor'];
      check.style.setProperty('borderColor', "");
      check.setAttribute('style', check.style.cssText + 'border-color' + ':' + sfc + " " + '!important');
      let check1 = document.querySelector('.mat-checkbox-checkmark-path') as HTMLElement;
      let pfc = environment.themeColors['primaryFontColor'];
      check1.style.setProperty('borderColor', "");
      check1.setAttribute('style', check.style.cssText + 'stroke' + ':' + pfc + " " + '!important');
    }, 200);
    // let DD = document.getElementById('DD');
    // DD && !DD.classList.contains('backactive') ? DD.classList.add('backactive') : DD.classList.remove('backactive');
    // DD.classList.toggle('backactive')
    let overall = document.getElementById('overall');
    let right = document.getElementById('show-right');
    right && !right.classList.contains('active') ? right.classList.add('active') : right.classList.remove('active');
    overall ? overall.classList.toggle('active') : '';
  }
  isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
  }
  sortData: any = {}
  sortbyfilter(data: any) {
    this.selectedValue = data;
    this.sortData = data;
    this.ValueSlectedSort = data;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Sort to ${data} Clicked by ${userId}`);
    const payload = {
      actionType: "product",
      metaData: {
        title: `Sort to ${data} Clicked`,
        sortType: data,
        collectionId: this.collectionIdUrl || null,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commanService?.slugInfo?.organization_id || null,
      networkGroupId: this.commanService.activeGroupId || null,
    }
    this.commanService.sendTriggeredEvent(payload);
    if (data == "Old-New") {
      this.selectedSortValue = "date_added"
      this.orderValue = "asc"
    }
    if (data == "New-Old") {
      this.selectedSortValue = "date_added"
      this.orderValue = "desc"
    }
    if (data == "Lowest-Highest") {
      this.selectedSortValue = "price"
      this.orderValue = "asc"
    }
    if (data == "Highest-Lowest") {
      this.selectedSortValue = "price"
      this.orderValue = "desc"
    }
    if (data == "Mosted Viewed") {
      this.selectedSortValue = "views"
      this.orderValue = "desc"
    }

    this.getFilterData('sort')
  }
  toggleTrue(id: number) {
    this.colors[id] = !this.colors[id];
  }
  public toggleButtonClass(name) {
    if (name) {
      this.isBlue = !this.isBlue;
    }
  }
  FinalSearch() {
    const cleanQuery = this.query?.trim();
    if (!cleanQuery) return;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Searched Product in Merchandise - "${this.query.trim()}" - ${userId}`);
    const data = {
      actionType: "product",
      metaData: {
        title: `Searched Product in Merchandise - "${this.query.trim()}`,
        searchQuery: this.query.trim(),
        collectionId: this.collectionIdUrl || null,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commanService?.slugInfo?.organization_id || null,
      networkGroupId: this.commanService.activeGroupId || null,
    }
    this.commanService.sendTriggeredEvent(data);
  }

  goBack() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Going back from collection - "${this.collectionIdUrl}" - ${userId}`);
    const data = {
      actionType: "product",
      metaData: {
        title: `Going back from collection - "${this.collectionIdUrl}" - ${userId}`,
        collectionId: this.collectionIdUrl,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commanService?.slugInfo?.organization_id || null,
      networkGroupId: this.commanService.activeGroupId || null,
      clickAction: `product`
    }
    this.commanService.sendTriggeredEvent(data);
    if(this.router.url.includes('/merchandise')) {
      this.router.navigate([this.commanService.getChannelBasePath(this.channelName) + '/merchandise/merch-list']);
    }
    else{
      this.router.navigateByUrl('/network-market/market');
    }
  }
  ngOnDestroy() {
    this.settingsDataSubscription?.unsubscribe();
    this.currencyInfoSubscription?.unsubscribe();
  }
}
